<template>
  <div class="my_edit">
    <CellGroup>
      <Cell title="头像" center>
        <img :src="userInfo.avatarurl" alt class="avatar" />
      </Cell>
      <Cell title="昵称" :value="userInfo.nickname"></Cell>
      <Cell
        title="姓名"
        :value="userInfo.name"
        input-align="right"
        is-link
        @click="showPopup('name')"
      ></Cell>
      <Cell
        title="手机号"
        :value="userInfo.phone"
        input-align="right"
        placeholder="请输入手机号码"
        type="number"
        is-link
        @click="showPopup('phone')"
      ></Cell>
      <Cell
        title="身份证号码"
        :value="userInfo.id_number"
        input-align="right"
        placeholder="请输入身份证号码"
        is-link
        @click="showPopup('id_number')"
      ></Cell>
      <Cell
        title="所属区"
        :value="userInfo.r_city? userInfo.r_city : '静安区'"
        input-align="right"
        placeholder="请输入所属区"
      ></Cell>
      <Cell
        title="所属街道"
        :value="userInfo.r_street? userInfo.r_street : ''"
        input-align="right"
        placeholder="请输入所属街道"
        is-link
        @click="showPopup('street')"
      ></Cell>
      <!-- <Cell
        title="地址"
        :value="userInfo.address"
        input-align="right"
        is-link
        @click="showPopup('address')"
      ></Cell> -->
    </CellGroup>

    <Popup v-model="show" closeable position="right" :style="{ height: '100%',width:'100%' }">
      <CellGroup title="信息修改" :border="false">
        <Field autofocus v-if="fieldShow.name" label="姓名" v-model="userInfo.name"></Field>
        <Field
          autofocus
          label="手机号"
          v-if="fieldShow.phone"
          v-model="userInfo.phone"
          placeholder="请输入手机号码"
          type="tel"
        ></Field>
        <Field
          autofocus
          label="身份证号码"
          v-if="fieldShow.id_number"
          v-model="userInfo.id_number"
          placeholder="请输入身份证号码"
        ></Field>
        <Field
          autofocus
          placeholder="请输入地址"
          label="地址"
          v-if="fieldShow.address"
          v-model="userInfo.address"
        ></Field>
        <Picker
          title="区"
          v-if="fieldShow.city"
          :columns="columns"
          @change="onChange"
        />
        <Picker
          title="街道"
          v-if="fieldShow.street"
          :columns="columns1"
          @change="onChange1"
        />
        <van-button
          style="display:block;margin:10px auto;width:80vw;"
          type="info"
          round
          block
          @click="editUserInfo"
        >提交</van-button>
      </CellGroup>
    </Popup>
  </div>
</template>
<style lang="less" scoped>
@import url("./index.less");
</style>
<script>
import { Cell, CellGroup, Field, Popup,Picker } from "vant";
import { mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      storeuserInfo: (state) => state.user.userInfo,
    }),
  },
  data() {
    return {
      userInfo: "",
      show: false,
      fieldShow: {},
      columns: [],
      citylist: [],
      columns1: [],
      streetlist: [],
      form: {}
    };
  },
  components: {
    Cell,
    CellGroup,
    Field,
    Popup,
    Picker
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    editUserInfo() {
      if (this.selectField == "id_number") {
        this.$dialog
          .confirm({
            title: "提示",
            message: "身份证号码提交后不可修改。确定提交?",
          })
          .then(() => {
            this.$api.user
              .editUserInfo({
                [this.selectField]: this.userInfo[this.selectField],
              })
              .then((res) => {
                if (res.status === 200) {
                  this.show = false;
                  this.$toast.success("操作成功");
                  this.getUserInfo(true);
                }
              });
            // on confirm
          })
          .catch(() => {
            // on cancel
          });
      } else if(this.selectField == "street") {
        this.$dialog
          .confirm({
            title: "提示",
            message: "请您一定确认自己所属区街道，提交后将不予修改，非本区也将无法参加本区线上达标赛。确定提交?",
          })
          .then(() => {
            this.$api.user
              .editRegion({
                form: JSON.stringify(this.form),
              })
              .then((res) => {
                if (res.status === 200) {
                  this.show = false;
                  this.$toast.success("操作成功");
                  this.getUserInfo(true);
                }
              });
            // on confirm
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.$api.user
          .editUserInfo({ [this.selectField]: this.userInfo[this.selectField] })
          .then((res) => {
            if (res.status === 200) {
              this.show = false;
              this.$toast.success("操作成功");
              this.getUserInfo(true);
            }
          });
      }
    },
    getUserInfo(update) {
      this.$toast.loading("加载中...");
      this.$api.user.getUserInfo().then((res) => {
        if (res.status * 1 === 200) {
          this.userInfo = res.data;
          this.storeuserInfo.userInfo = res.data;
          this.setUserInfo(this.storeuserInfo);
        }
        setTimeout(() => {
          this.$toast.clear();
        }, 500);
      });
    },
    showPopup(field) {
      if (field === "id_number" && !!this.userInfo[field]) {
        this.$toast("身份证号码不允许修改");
        return;
      }
      // if (field === "city" && !!this.userInfo.r_city) {
      //   this.$toast("所属区不允许修改");
      //   return;
      // }
      if (field === "street" && !!this.userInfo.r_street) {
        this.$toast("所属街道不允许修改");
        return;
      }
      // if(field === "street" && !this.userInfo.r_city){
      //   this.$toast("请先填写所在区");
      //   return;
      // }
      // if (field === "city"){
      //   this.$api.user.getRegion({pid:45053}).then(res=>{
      //     if(res.status == 200) {
      //       this.columns =  res.columns
      //       this.citylist = res.data
      //       this.form = {
      //         cid: res.data[0].id,
      //         city: res.data[0].name
      //       }
      //     }
      //   })
      // }

      if (field === "street"){
        this.$api.user.getRegion({pid:147}).then(res=>{
          if(res.status == 200) {
            this.columns1 =  res.columns
            this.streetlist = res.data
            this.form = {
              cid: 147,
              city: '静安区',
              sid: res.data[0].id,
              street: res.data[0].name
            }
          }
        })
      }
      
      this.show = true;
      this.fieldShow = Object.assign({}, { [field]: true });
      this.selectField = field;
    },
    onChange(picker, value, index) {
      let item = this.citylist.find(ele=>ele.name===value)
      this.form = {
        cid: item.id,
        city: item.name
      }
    },
    onChange1(picker, value, index) {
      let item = this.streetlist.find(ele=>ele.name===value)
      this.form.sid = item.id
      this.form.street = item.name
    },
  },
  mounted() {
    this.getUserInfo();
  },
};
</script>
